import { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GrContact } from "react-icons/gr";
import { dataCy, SELECTORS } from '../../utils/dataCy';
import { localizeDomain } from '../../utils/localizeDomain';


const ArticleNav = () => {
  const { t } = useTranslation('article', 'home');
  const location = useLocation();
  const { category } = useParams();
  const navigate = useNavigate();
  const [headings, setHeadings] = useState([]);
  const [activeHeading, setActiveHeading] = useState('');
  const isApiCategory = category === 'api';

  const updateHeadings = () => {
    const articleContent = document.querySelector('.prose'); // Asegúrate de que el selector sea específico
    if (!articleContent) return;

    const h2Elements = articleContent.querySelectorAll('h2');
    const headingList = Array.from(h2Elements)
      .filter((h2) => h2.innerText.trim() !== '') // Filtrar <h2> vacíos o sin contenido
      .map((h2) => {
        const id = h2.id || h2.innerText.replace(/\s+/g, '-').toLowerCase();
        if (!h2.id) h2.id = id; // Asignar ID si no existe
        return { id, text: h2.innerText };
      });

    setHeadings(headingList);
  };

  useEffect(() => {
    // Crear un observer para detectar cambios en el DOM
    const observer = new MutationObserver(updateHeadings);
    const articleContent = document.querySelector('.prose');
    if (articleContent) {
      observer.observe(articleContent, { childList: true, subtree: true });
    }

    // Ejecutar inicialmente para capturar los encabezados ya presentes
    updateHeadings();

    // Limpiar el observer al desmontar el componente
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Ejecutar updateHeadings cuando cambie la URL
    updateHeadings();
    
    // Para API, manejar el hash inicial en la URL
    if (isApiCategory && location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          setActiveHeading(location.hash.substring(1));
        }
      }, 100);
    }
  }, [location.pathname, location.hash, isApiCategory]);

  useEffect(() => {
    // Función para detectar el heading activo al hacer scroll
    const handleScroll = () => {
      const h2Elements = document.querySelectorAll('h2');
      let currentHeading = '';
      h2Elements.forEach((h2) => {
        const rect = h2.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom > 0) {
          currentHeading = h2.id;
        }
      });
      setActiveHeading(currentHeading);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
      <div className={`mb-4 ${!isApiCategory ? 'sticky top-28' : ''}`}>
        <div className=" bg-gray-50 dark:bg-grayButton p-4 rounded-lg shadow-md">
          <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100 mb-4">
            {t('navigateArticle')}
          </h3>
          <ul className="space-y-4">
            {headings.map((heading) => (
              <li key={heading.id}>
                <a
                  href={`#${heading.id}`}
                  className={`flex items-center text-gray-700 hover:text-secondBg dark:text-gray-300 dark:hover:text-secondBg ${activeHeading === heading.id
                    ? 'text-secondBg font-bold dark:text-secondBg'
                    : ''
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (isApiCategory) {
                      // Para API, actualizar la URL con el hash
                      const currentUrl = new URL(window.location);
                      currentUrl.hash = heading.id;
                      window.history.pushState({}, '', currentUrl);
                    }
                    document.getElementById(heading.id)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  data-cy={dataCy(SELECTORS.LINK, `nav-heading-${heading.id}`)}
                >
                  {/*   <div className="relative w-2 h-2 mr-2">
                   Ícono para el tema claro 
                  <img className="w-full h-full dark:hidden" src={HashBlack} alt="Hash Black" />

                   Ícono para el tema oscuro 
                  <img className="w-full h-full hidden dark:block" src={Hash} alt="Hash" />
                </div>*/}

                  {heading.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
        {!isApiCategory && (
          <div className="mt-6 hidden sm:hidden md:hidden lg:block w-fit">
            <a
              href={localizeDomain("mailto:support@excent.capital")}
              className="px-8 py-3 bg-secondBg text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 dark:hover:bg-blue-700 transition-colors flex items-center gap-2 w-fit"
              data-cy={dataCy(SELECTORS.LINK, 'nav-contact')}
            >
              <GrContact className="text-xl" />
              {t('getInTouch', 'Get in Touch')}
            </a>
          </div>
        )}

      </div>

  );
};

export default ArticleNav;
